import type { ExternalTableSchema } from '@packages/table-builder';

export const planGrantDocumentTable: ExternalTableSchema = {
  metadata: {
    title: 'Plan Grant Documents',
    entity: 'Plan Grant Document',
  },

  dataSource: {
    endpoint: '/api/award/api/app/plan/plan-grant-document-detail-by-id/{Id}',
    method: 'GET',
    rowIdField: 'id',
  },

  columns: [
    { field: 'createdDate', header: 'Uploaded Time', type: 'date', width: 180 },
    { field: 'fileContentName', header: 'Document Name', type: 'text', width: 180 },
    { field: 'effectiveDate', header: 'Effective Date', type: 'date', width: 180, editable: { type: 'date', placeholder: 'MM/DD/YYYY' } },
    {
      field: 'isActive',
      header: 'Status',
      type: 'badge',
      width: 155,
      align: 'center',
      conditionalValues: { true: 'ACTIVE', false: 'INACTIVE' },
      badge: { statusMap: { ACTIVE: 'success', INACTIVE: 'error' } },
      editable: { type: 'asyncSelect' },
      dataSource: {
        url: '/api/award/api/app/status-dropdown-app-services/active-status',
        mapper: { label: 'name', value: 'value' },
      },
    },
  ],

  actions: {
    toolbar: {
      primary: { id: 'ADD_DOCUMENT_DETAIL_PLAN_GRANT_DOCUMENT', label: 'Add Document' },
    },
    row: [
      { id: 'EDIT_PLAN_GRANT_DOCUMENT', label: 'Edit', actionType: 'startEditing' },
      { id: 'DELETE_PLAN_GRANT_DOCUMENT', label: 'Delete', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    editing: { bulkSave: false },
  },
};
